export default "__VITE_ASSET__549a96b3__"